import translations from "@/config/translations";
import useAuthStore from "@/hooks/useAuthStore";
import useDashboardStore from "@/hooks/useDashboardStore";
import useLangStore from "@/hooks/useLangStore";
import "./styles.css";

export default function StoreSwitcherPopup({ onClose }: { onClose: () => void; details?: any }) {
    const { lang } = useLangStore();
    const { client } = useAuthStore();
    const { store, setStore } = useDashboardStore();
    const t = translations[lang ?? "ar"].selectStore;

    const ownedStores: any[] = client?.owner ?? [];
    const permissionStores: any[] = (client?.permissions ?? []).map((p: any) => p.store).filter((s: any) => s && typeof s === "object");

    const allStores = [...ownedStores, ...permissionStores].reduce((acc: any[], s: any) => {
        if (s?._id && !acc.some((x) => x._id === s._id)) acc.push(s);
        return acc;
    }, []);

    const getStoreName = (s: any): string => {
        if (!s?.name) return "—";
        if (typeof s.name === "string") return s.name;
        if (Array.isArray(s.name)) {
            const match = s.name.find((n: any) => n.lang === lang) ?? s.name[0];
            return match?.value ?? "—";
        }
        return "—";
    };

    const handleSelect = (s: any) => {
        setStore(s._id, s);
        onClose();
    };

    return (
        <div className="store-switcher-popup">
            <p className="store-switcher-title">{t.title}</p>
            <div className="store-switcher-list">
                {allStores.map((s) => {
                    const name = getStoreName(s);
                    const firstLetter = name !== "—" ? name.charAt(0) : "?";
                    const isActive = s._id === store?._id;
                    return (
                        <button
                            key={s._id}
                            className={`store-switcher-card${isActive ? " store-switcher-card--active" : ""}`}
                            onClick={() => handleSelect(s)}
                            type="button"
                        >
                            <div className="store-switcher-logo-wrap">
                                {s.logo ? (
                                    <img className="store-switcher-logo" src={s.logo} alt={name} />
                                ) : (
                                    <span className="store-switcher-logo-placeholder">{firstLetter}</span>
                                )}
                            </div>
                            <div className="store-switcher-info">
                                {s.type && <p className="store-switcher-type">{s.type}</p>}
                                <p className="store-switcher-name">{name}</p>
                            </div>
                            {isActive && <div className="store-switcher-active-dot" />}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
